export default __webpack_public_path__ + "static/media/FlyingFrog2.585878d5.png";